import { ButtonStyle, SiteCorebuttonData } from './button.types';

function capitalizeFirstLetter(val?: string) {
  if (!val) '';
  return String(val).charAt(0).toUpperCase() + String(val).slice(1).toLowerCase();
}

function generateButtonStyles(data: SiteCorebuttonData): ButtonStyle | null {
  if (!data) return null;
  return {
    height: data?.buttonHeight?.value,
    background: {
      default: data?.enabledBackgroundColor?.value,
      hover: data?.hoverBackgroundColor?.value,
      disabled: data?.disabledBackgroundColor?.value,
    },
    borderRadius: data?.buttonBorderRadius?.value,
    textColor: {
      hover: data?.hoverTextColor?.value,
      default: data?.enabledTextColor?.value,
      disabled: data?.disabledTextColor?.value,
    },
    borderColor: {
      hover: data?.hoverBorderColor?.value,
      default: data?.enabledBorderColor?.value,
      disabled: data?.disabledBorderColor?.value || data?.enabledBorderColor?.value + '7A',
    },
    focusedBorderColor: data?.focusedBorderColor?.value,
  };
}

type ButtonStylesCustom = {
  disabledOpacity?: string;
};

function applyButtonStyles(
  data?: ReturnType<typeof generateButtonStyles>,
  options?: ButtonStylesCustom
) {
  if (!data) null;
  const enableBorder = !!data?.borderColor?.default && data?.borderColor?.default !== 'unset';

  return {
    fontSize: '16px',
    borderRadius: data?.borderRadius,
    background: data?.background.default,
    color: data?.textColor.default,
    borderWidth: enableBorder ? '1px' : 0,
    borderColor: data?.borderColor?.default,
    borderStyle: 'solid',
    '&:hover': {
      background: data?.background.hover,
      color: data?.textColor.hover,
      borderColor: data?.borderColor?.hover,
    },
    '&:disabled': {
      background: data?.background.disabled,
      borderColor: data?.borderColor?.default + '48',
      color: data?.textColor.disabled,
      opacity: options?.disabledOpacity || 1,
      borderColor: data?.borderColor?.disabled,
    },
  };
}

export { capitalizeFirstLetter, generateButtonStyles, applyButtonStyles };
